import React from 'react';
import { Horizontal } from './galleries/horizontal/index.js';
import { Overlay } from './galleries/overlay';

const Gallery = ({
  items,
  galleryType,
  scrollContainerId,
  initTimelines,
  enableAnimation,
  setAnimationDuration,
  staticImage,
  staticPosition,
  overlayVertical,
  overlayHorizontal,
  overlayAlignment,
  fullHeight,
  imagePadding,
  customCss,
}) => {
  const getGalleryComponent = () => {
    let C;
    switch (galleryType) {
      case 'overlay':
        C = Overlay;
        break;
      case 'horizontal':
        C = Horizontal;
        break;
      default:
        C = Horizontal;
        break;
    }

    return C;
  };

  const GalleryComponent = getGalleryComponent();

  return (
    <GalleryComponent
      items={items}
      initTimelines={initTimelines}
      scrollContainerId={scrollContainerId}
      enableAnimation={enableAnimation}
      setAnimationDuration={setAnimationDuration}
      fullHeight={fullHeight}
      imagePadding={imagePadding}
      customCss={customCss}
      {...(galleryType === 'overlay' && {
        staticImage: staticImage,
        staticPosition: staticPosition,
        overlayHorizontal: overlayHorizontal,
        overlayVertical: overlayVertical,
        overlayAlignment: overlayAlignment,
      })}
    />
  );
};

export { Gallery };
